import React, { createContext, useContext, useMemo, useState } from 'react';

/** Shared hover state so the Experience graph and the Skills section light each other up. */
const Ctx = createContext({ skill: null, role: null, setSkill: () => {}, setRole: () => {} });

export function HighlightProvider({ children }) {
  const [skill, setSkill] = useState(null);
  const [role, setRole] = useState(null);
  const value = useMemo(() => ({ skill, role, setSkill, setRole }), [skill, role]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useHighlight = () => useContext(Ctx);

/** Loose match between a skill name and a graph tag (e.g. "Spring Boot" ↔ "Spring Boot 3.4", "Supabase" ↔ "Supabase Edge"). */
export function skillMatchesTag(skill, tag) {
  if (!skill || !tag) return false;
  const norm = (s) => s.toLowerCase().replace(/\(.*?\)/g, '').replace(/[^a-z0-9+#]/g, '');
  const a = norm(skill), b = norm(tag);
  if (!a || !b) return false;
  if (a === b) return true;
  if (a.length >= 4 && b.includes(a)) return true;
  if (b.length >= 4 && a.includes(b)) return true;
  // first token match for compound names like "Kotlin · Spring Boot"
  return skill.split(/[·/,]/).some((part) => { const p = norm(part); return p.length >= 4 && (p === b || b.includes(p)); });
}
